import React, { useEffect, useRef, useState } from "react";

import { ToggleTabsList } from "../../../models";

interface UseToggleTabsProps {
  toggleTabsList: ToggleTabsList;
  currentTab: string;
}

interface UseToggleTabsReturnData {
  value: string;
  setValue: (value: string) => void;
  tabsRef: React.MutableRefObject<(HTMLDivElement | null)[]>;
}

export const useToggleTabs = ({ toggleTabsList, currentTab }: UseToggleTabsProps): UseToggleTabsReturnData => {
  const [value, setValue] = useState(currentTab);
  const tabsRef = useRef<(HTMLDivElement | null)[]>([]);

  const updateIndicator = (): void => {
    const activeTab = tabsRef.current[toggleTabsList.findIndex((tab) => tab.label === value)];
    const activeIndicator = tabsRef.current[toggleTabsList.length];

    if (activeTab && activeIndicator) {
      activeIndicator.style.width = `${activeTab.offsetWidth}px`;
      activeIndicator.style.transform = `translateX(${activeTab.offsetLeft}px)`;
    }
  };

  useEffect(() => {
    updateIndicator();
  }, [value, toggleTabsList, tabsRef]);

  useEffect(() => {
    const handleResize = (): void => updateIndicator();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [value, toggleTabsList, tabsRef]);

  return {
    value,
    setValue,
    tabsRef,
  };
};
